import { useRef, useState } from 'react';

const useToolTip = ({ defaultShow = false } = {}) => {
  const targetRef = useRef();
  const [showToolTip, setShowToolTip] = useState(defaultShow);

  const onMouseEnter = () => {
    setShowToolTip(true);
  };

  const onMouseLeave = () => {
    setShowToolTip(false);
  };

  return {
    targetRef,
    showToolTip,
    onHoverHandlers: {
      onMouseEnter,
      onMouseLeave
    }
  };
};

export default useToolTip;
